/* eslint-disable import/no-anonymous-default-export */
import * as Yup from 'yup';

import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { get } from 'services/config';


const Schema1 = (type:any)=> Yup.object().shape({
  societe: Yup.string()
    .min(2, 'Trop court !')
    .max(100, 'Trop long !').test('check-societe-required', 'Le nom de la société est requis.', (value:any)=> type==='freelance' || value),
  nom: Yup.string()
    .min(2, 'Trop court !')
    .max(100, 'Trop long !').test('check-nom-required', 'Le nom est requis.', (value:any)=> type==='enterprise' || value),
  prenom: Yup.string()
    .min(2, 'Trop court !')
    .max(100, 'Trop long !').test('check-prenom-required', 'Le prénom est requis.', (value:any)=> type==='enterprise' || value),
  nom_prenom: Yup.string()
    .min(2, 'Trop court !')
    .max(100, 'Trop long !').test('check-nom_prenom-required', 'Le nom et prénom sont requis.', (value:any)=> type==='freelance' || value),
  mail: Yup.string()
    .email('Adresse email invalide.')
    .required('L\'adresse email est requise.'),
  telephone: Yup.string()
    .transform((value) => value.replace(/\s+/g, '')) // Remove all spaces
    .required('Le numéro de téléphone est requis.')
    .matches(
      /^\+[1-9]\d{1,3}[1-9]\d{6,14}$/,
      "Le numéro de téléphone doit inclure un indicatif valide et être au bon format."
    ).test('is-valid-phone', 'Le numéro de téléphone doit inclure un indicatif valide et être au bon format.', function (value) {
      const { countryCode } = this.parent; // Access the country field dynamically
      if (!countryCode || !value) return false; // Skip validation if either is missing

      const phoneNumber = parsePhoneNumberFromString(value, countryCode);
      return phoneNumber && phoneNumber.isValid();
    }),
  countryCode:Yup.string(),
  pays: Yup.string().test('check-required', 'Le pays est requis', (value:any)=> type==='freelance' || value)
});

  const SUPPORTED_FORMATS:any = {
    audio: [
      "audio/mpeg", // .mp3
      "audio/wav",  // .wav
      "audio/ogg",  // .ogg
      ".mp3",
      ".wav",
      ".ogg"
    ],
    images: [
      "image/jpeg", // .jpg, .jpeg
      "image/png",  // .png
      "image/gif",  // .gif
      "image/webp", // .webp
      ".jpg",
      ".jpeg",
      ".png",
      ".gif",
      ".webp"
    ],
    documents: [
      "application/pdf",                // .pdf
      "application/msword",             // .doc
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
      "application/vnd.ms-excel",       // .xls
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
      "application/vnd.ms-powerpoint", // .ppt
      "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
      ".pdf",
      ".doc",
      ".docx",
      ".xls",
      ".xlsx",
      ".ppt",
      ".pptx"
    ]
  };
  
  const Schema2 = (type:string)=>{ 
    if (type === 'freelance'){
      return Yup.object().shape({
        language: Yup.array()
        .of(
          Yup.number()
        ).min(1, 'La langue est requise.')
        .transform((val) => (Array.isArray(val) ? val.map(item => item.id || '') : []))
        .required('La langue est requise.'),
        // tools: Yup.array().of(Yup.number()).min(1, "La selection d'outils est requise.")
        // .transform((val) => (Array.isArray(val) ? val.map(item => item.id || '') : []))
        // .required("La selection d'outils est requise"),
        description: Yup.string()
          .required('La description est requise.'),
        domaine_favoris: Yup.string()
          .required('Le domaine favoris est requis.'),
        file: Yup.object()
        .test(
          "fileRequired",
          "Le fichier audio est requis.",
          (file:any, context) => {
            const { domainInfo } = context.parent;
            console.log({file, context,test:domainInfo.some((info:any) => info.name?.audio === true) ? !!file : true})
            return domainInfo.some((info:any) => info.name?.audio === true) ? !!file?.name  : true;
          }
        )
          // .required('Le fichier audio est requis.')
        .test(
          "fileFormat",
          "Format de fichier non pris en charge. Les formats autorisés sont : mp3, ogg, wav.", 
          (value: any) => {
            if(Object.keys(value).length){
                let val = value;
                console.log(
                  'tester',
                  SUPPORTED_FORMATS['audio'].includes(val.type) ||
                    SUPPORTED_FORMATS['audio'].includes(`.${val.name.split('.').pop()}`)
                );
                return (
                  SUPPORTED_FORMATS['audio'].includes(val.type) ||
                  SUPPORTED_FORMATS['audio'].includes(`.${val.name.split('.').pop()}`)
                );
            }else{
              return true
            }
          }
        ),
        domainInfo: Yup.array().of(
          Yup.object({
            name: Yup.object().transform((val) => (typeof val === 'object' ? {name:val.value, audio: val?.audio} : val)).required('Le nom du domaine est requis'),
            skills: Yup.array().of(
              Yup.object({
                skill: Yup.string().transform((val) => (typeof val === 'object' ? val?.value || '' : val)).required('La compétence est requise'),
                experience: Yup.number()
                  .typeError('L\'année d\'expérience est requise')
                  .required('L\'année d\'expérience doit être un nombre'),
                // durationType: Yup.string().oneOf(['an', 'mois'], 'Invalid duration type'),
              })
            ),
          })
        ),
      });      
    }
  }

  const Schema4 = (type: string) => { 
    if (type === 'freelance') {
      return Yup.object().shape({
        statut:Yup.string().transform((val) => (typeof val === 'object' ? val?.value || '' : val))
          .required('Le statut est requis.'),
        tarifMensuel: Yup.string()
          .required('Le tarif mensuel est requis.')
          .matches(/^\d+$/, 'Seules les valeurs numériques sont autorisées.'),
      });
    }
  };
  

  const Schema5 = Yup.object().shape({
    username: Yup.string()
      .min(2, 'Trop court !')
      .max(100, 'Trop long !')
      .required('Le nom d’utilisateur est requis.')
      .test('check-username', 'Ce nom d\'utilisateur existe déja', async (value) =>{
        if (!value) return false;

        try {
          const res:any = await get(`/api/email/checker?email=${value}`);
          if(res?.data?.status === "success"){
            return !res?.data?.data?.username_already_exist
          }else{
            return false
          }
        } catch (err) {
          console.error('Erreur API :', err);
          return false
        }


      }),
    picture: Yup.object()
      .required('L’image est requise.'),
  });
  

  const Schema6 = (type: string) => {
    if (type === "enterprise") {
      return Yup.object().shape({
        function: Yup.string()
          .min(2, 'Trop court !')
          .max(100, 'Trop long !')
          .required('La fonction est requise.'),
        id_num: Yup.number()
          .typeError('Le numéro d\'identification doit être un nombre.')
          .required('Le numéro d\'identification est requis.'),
      });
    } else {
      return Yup.object().shape({
        date: Yup.string().matches(
          /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d\d$/,
          'La date doit être au format DD/MM/YYYY'
        ).required('La date est requise.'),
        ville: Yup.string()
          .required('La ville est requise.'),
      });
    }
  };
  

  const Schema7 = (type: string) => {
    if (type === "enterprise") {
      // Add enterprise logic here if needed
    } else {
      return Yup.object().shape({
        pays: Yup.string()
          .required('Le pays est requis.'),
        ville: Yup.string()
          .required('La ville est requise.'),
      });
    }
  };

  const contractSchema = Yup.object({
    contractAcknowledged: Yup.boolean()
      .oneOf([true], 'Vous devez reconnaître avoir lu le contrat.')
      .required('Ce champ est obligatoire.'),
    termsAcknowledged: Yup.boolean()
      .oneOf([true], 'Vous devez reconnaître avoir lu les CGU.')
      .required('Ce champ est obligatoire.')
  });


  const profilWorkerSchema = Yup.object({
    // justificatifIdentite: Yup.object().required("Justificatif identite est requis"),
    // justificatifDomicile: Yup.object().required("Justificatif domicile est requis"),
    // cv: Yup.object().required("Cv est requis"),
    // certificatImmatriculation: Yup.object().required("Certificat dimmatriculation est requis"),
    // rib: Yup.object().required("Rib est requis"),
    // documentsComplementaires: Yup.object().required("Documents complementaires est requis"),
    autorisationLogo: Yup.boolean()
      .oneOf([true], 'Vous devez autorisé Wall Of Share  à utiliser votre logo/image.')
      .required('Ce champ est obligatoire.'),
      certificationAuthenticite: Yup.boolean()
      .oneOf([true], 'Vous devez reconnaître que l’ensemble des documents et informations téléchargés sont authentiques, sincères et véritables..')
      .required('Ce champ est obligatoire.')
  });
  


  

  const formSteps = {
    step1:Schema1,
    step5:Schema5,
    step7:Schema7,
    step4:Schema4,
    step2:Schema2,
    step6:Schema6,
    contract:contractSchema,
  }
  

  export  {
    formSteps,
    profilWorkerSchema
  };